import React from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'

import CONFIG from '../../config'
import LinkButton from '../controls/LinkButton'

class UnitAdminPanelView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    unit: PropTypes.object.isRequired,
  }

  static styles = () => ({
    actions: {
      position: 'absolute',
      right: 0,
      zIndex: 1,
    },
    links: {
      display: 'block',
    },
  })

  render() {
    const { classes, unit } = this.props

    return (
      <div className={classes.actions}>
        <Typography variant="subtitle1">
          Admin Panel
        </Typography>
        <Typography>Serial Number: {unit.serial}</Typography>
        <LinkButton
          size="small"
          to={`${CONFIG.blokable.adminBaseUrl}/units/${unit.id}/devices`}
          className={classes.links}
        >
          View Devices
        </LinkButton>
        <LinkButton
          size="small"
          to={`${CONFIG.blokable.adminBaseUrl}/units/${unit.id}/timeseries`}
          className={classes.links}
        >
          View Timeseries
        </LinkButton>
        <LinkButton
          size="small"
          to={`${CONFIG.blokable.adminBaseUrl}/units/${unit.id}/rules`}
          className={classes.links}
        >
          View Alert Rules
        </LinkButton>
        <LinkButton
          size="small"
          to={`${CONFIG.blokable.adminBaseUrl}/units/${unit.id}/automations`}
          className={classes.links}
        >
          View Automations
        </LinkButton>
      </div>
    )
  }
}

export default withStyles(UnitAdminPanelView.styles)(UnitAdminPanelView)
